import { createSelector } from '@ngrx/store';
import { selectState } from '../../config/selectors';

const selectQuizProgressState = createSelector(selectState, (state) => state.quizProgress);

export const selectQuizId = createSelector(selectQuizProgressState, (state) => state.quizId);
export const selectProgress = createSelector(selectQuizProgressState, (state) => state.progress);
export const selectLoading = createSelector(selectQuizProgressState, (state) => state.loading);
export const selectLoaded = createSelector(selectQuizProgressState, (state) => state.loaded);
export const selectSaving = createSelector(selectQuizProgressState, (state) => state.saving);
export const selectRetrying = createSelector(selectQuizProgressState, (state) => state.retrying);
export const selectIsFinished = createSelector(selectProgress, (progress) => progress?.finished ?? false);
export const selectIsPassed = createSelector(selectProgress, (progress) => progress?.passed ?? false);
export const selectAnswers = createSelector(selectProgress, (progress) => progress?.answers ?? []);

export const selectSelectedOption = (questionId: string) =>
    createSelector(selectProgress, (progress) => {
        if (!progress) return null;
        const answer = progress.answers.find((a) => a.questionId === questionId);
        return answer?.optionId ?? null;
    });
